import { Accordion, Button, Group, MediaQuery } from '@mantine/core';

function AccordionList({data}) {
  return (
    <Accordion variant="contained" radius="xl" defaultValue={0} mt={25}>
      {
        data.map((item, idx) => 
        <Accordion.Item key={idx} value={idx.toString()}>
          <Accordion.Control>{item.titleText}</Accordion.Control>
          <Accordion.Panel>{item.descriptionText}{item.links && 
          <Group mt={25}>
          {
            item.links.map((link, ldx) => <Button key={ldx} component='a' href={link.url}>{link.linkText}</Button>)
          } 
          </Group>}
          </Accordion.Panel>
        </Accordion.Item>)
      }
    </Accordion>
  );
}

export default AccordionList;